export default __webpack_public_path__ + "static/media/instamart-logo.ecf91b3c.svg";